export default __webpack_public_path__ + "images/9d5bd32d601a70dcf7f726d5f8d1dc61.svg";